import { Card } from "@mui/material";
import React from "react";

const CardDetailTopComponent = () => {
  return (
    <div className="container">
      <Card style={{ padding: 5 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            lineHeight: 1,
          }}
        >
          <span>
            Unbeatable Kerala Fly-N-Stay
            <br />
            <span style={{ fontSize: "14px" }}>
              5 Nights /6 Days | (TRKUBK-L)
            </span>
          </span>
          <span>
            Starting from <label style={{ color: "#f15d30" }}>₹ 23750 </label>{" "}
            per person on twin sharing
          </span>
        </div>
      </Card>
    </div>
  );
};

export default CardDetailTopComponent;
